import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";

import { useAuth } from "../../../context/API_Client";
import PspCard from "./PspCard";
import { BiSearch } from "react-icons/bi";
import CustomButton from "../../../reusableComponents/CustomButton";
import "./gatewayStyle.css";

const SelectPaymentGateways = (props) => {
  const { getAllPspConfigs } = useAuth();
  const [paymentGateways, setPaymentGateways] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const [toggled, setToggled] = useState(false);
  const [off, setOff] = useState(false);
  useEffect(() => {
    getAllPspConfigs((data) => {

      setPaymentGateways(
        data.map((pspConfig) => {
          return {
            title: pspConfig.title,
            value: pspConfig.pspCode,
            logoUrl: pspConfig.pspLogoUrl,
          };
        })
      );
    });
  }, []);

  const [filteredGateways, setFilteredPaymentGateways] = useState([]);
  useEffect(() => {
    const filteredGateways = paymentGateways.filter((ele) =>
      ele.title.toLowerCase().includes(inputValue.toLowerCase())
    );
    setFilteredPaymentGateways(filteredGateways);
  }, [inputValue, paymentGateways]);

  const handleTabChange = () => {
    props.setValue(1);
  };

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div>
          <div
            className="btn-group"
            style={{
              borderRadius: "10px",
              marginRight: "20px",
              height: "42px",
              width: "300px",
              border: "1px solid rgba(1, 1, 2, 0.45)",
              marginBottom: "20px",
            }}
          >
            <BiSearch
              style={{
                marginTop: "7px",
                height: "28px",
                width: "28px",
                color: "#C2C2C2",
                marginRight: "4px",
                marginLeft: "12px",
              }}
            />
            <input
              type="text"
              value={inputValue}
              disabled={toggled || props.pspSelected?.length > 0}
              onChange={(eve) => setInputValue(eve.target.value)}
              style={{
                border: "none",
                borderRadius: "10px",
                outline: "none",
                marginLeft: "-4px",
                fontSize: "14px",
                width: "100%",
              }}
              placeholder="Search gateways"
            />
          </div>
          <div style={{ display: "flex", gap: "4px" }}>
            <img src="/assets/stars.svg" style={{ marginTop: "-8px" }} />
            <Typography
              className="gatewayHeading"
              style={{
                marginBottom: "8px",
              }}
            >
              Available Gateways
            </Typography>
          </div>
          <div
            style={{
              overflowY: "scroll",
              height: "49vh",
              padding: "2px",
              margin: "-3px",
            }}
          >
            {filteredGateways?.length > 0 ? (
              filteredGateways?.map((obj, index) => (
                <PspCard
                  filteredGateways={filteredGateways}
                  obj={obj}
                  pspSelected={props.pspSelected}
                  setPspSelected={props.setPspSelected}
                  toggled={toggled}
                  setToggled={setToggled}
                  getMethodsForPspAndType={props.getMethodsForPspAndType}
                  payload={props.payload}
                  setPayload={props.setPayload}
                  off={off}
                  setOff={setOff}
                  storeCreds={props.storeCreds}
                  setStoreCreds={props.setStoreCreds}
                  setPspSaved={props.setPspSaved}
                  pspSaved={props.pspSaved}
                  getSupportedMethods={props.getSupportedMethods}
                />
              ))
            ) : (
              <Typography
                className="gatewayHeading"
                style={{ marginTop: "10px" }}
              >
                No Gateway found
              </Typography>
            )}
          </div>
        </div>
        <span
          style={{
            marginTop: "-20px",
            marginBottom: "-20px",
            marginLeft: "3px",
          }}
        >
          <Divider orientation="vertical" color="#C2C2C2" />
        </span>

        {!toggled && (
          <div
            style={{ display: "flex", flexDirection: "column", width: "100%" }}
          >
            <img
              src="/assets/EmptyStateIcon.svg"
              style={{
                height: "120px",
                marginTop: "12%",
                justifyContent: "center",
              }}
            />
            <div
              style={{
                display: "flex",
                marginTop: "20px",
                justifyContent: "center",
              }}
            >
              <Typography style={{ fontSize: "17px" }} variant="h7">
                {props.pspSelected?.length == 0 ? (
                  <> Add Payment Gateway </>
                ) : props.pspSelected?.length == 1 ? (
                  <>Payment Gateway added</>
                ) : (
                  <>Payment Gateways added</>
                )}
              </Typography>
            </div>

            {props.pspSelected?.length == 0 && (
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                <Typography
                  variant="body1"
                  style={{
                    color: "var(--text-medium, rgba(1, 1, 2, 0.60))",
                    fontSize: "14px",
                    textAlign: "center",
                  }}
                >
                  Please add payment gateway to get started with the platform
                </Typography>
              </div>
            )}
            {props.pspSelected?.length > 0 && (
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  marginTop: "10px",
                }}
              >
                <CustomButton
                  text={"Continue to next step"}
                  type={"primary"}
                  size={"md"}
                  onClick={handleTabChange}
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectPaymentGateways;
